import { selector } from '@/lib/selectors';
import { sortOrganizations, filterOrganizations } from '@/domain/organization/helpers';
import { organizationNotificationsSelector } from '@/domain/companies/companiesSelector';
import { organizationSelector, currentOrganizationSelector } from '@/domain/organization/organizationLeafSelectors';

export * from '@/domain/organization/organizationLeafSelectors';

export const organizationIsPaidSelector = selector(organizationSelector, (o) => o.is_paid);
export const organizationSigningsSelector = selector(organizationSelector, (o) => o.signings);
export const organizationFeaturesSelector = selector(organizationSelector, (o) => {
  return o.features;
});

const twoFAFeatures = ['two_fa'];
const ssoFeatures = ['sso', 'restrict_email_domain'];
const ipWhitelistFeatures = ['ip_whitelist'];

export const organizationFeaturesWithoutHiddenSelector = selector(organizationFeaturesSelector, (features) => {
  return features.filter((v) => v.state !== 'hidden');
});

export const organizationSecurity2FAFeaturesSelector = selector(organizationFeaturesWithoutHiddenSelector, (f) => {
  return f.filter((v, k) => twoFAFeatures.includes(k));
});

export const organizationSecuritySSOFeaturesSelector = selector(organizationFeaturesWithoutHiddenSelector, (f) =>
  f.filter((v, k) => ssoFeatures.includes(k)),
);

export const organizationSecurityIPWhitelistFeaturesSelector = selector(organizationFeaturesWithoutHiddenSelector, (f) =>
  f.filter((v, k) => ipWhitelistFeatures.includes(k)),
);
export const organizationBackupConnectionSelector = selector(organizationSelector, (o) => o.backupConnection);
export const organizationWhatsappPhoneSelector = selector(organizationSelector, (o) => o.whatsapp_phone);
export const organizationPasswordExpirationDaysSelector = selector(organizationSelector, (o) => o.expiration_days);
export const organizationDomainSelector = selector(organizationSelector, (o) => o.domain);
export const organizationIpWhitelistSelector = selector(organizationSelector, (o) => o.ip_whitelist);

// list
export const organizationListSelector = selector(organizationSelector, (o) => o.list);
export const organizationLoadedSelector = selector(organizationSelector, (o) => o.loaded);
export const organizationSortSelector = selector(organizationSelector, (o) => o.sort);
export const organizationFilterSelector = selector(organizationSelector, (o) => o.filter);
export const organizationDateFormatSelector = selector(organizationSelector, (o) => o.dateFormat);
export const organizationCountrySelector = selector(organizationSelector, (o) => o.country);

// unfiltered list
export const organizationUnfilteredListSelector = selector(
  organizationListSelector,
  organizationSortSelector,
  organizationNotificationsSelector,
  sortOrganizations,
);

export const organizationFilteredListSelector = selector(
  organizationUnfilteredListSelector,
  organizationFilterSelector,
  filterOrganizations,
);

export const currentOrganizationDataSelector = selector(
  currentOrganizationSelector,
  organizationListSelector,
  (id, list) => list.find((org) => org.id === id),
);

// checks if current org was set
export const isCurrentOrganizationSetSelector = selector(currentOrganizationSelector, (org) => org !== null);

export const userHasMultipleOrgsSelector = selector(organizationListSelector, (list) => list.size > 1);
